if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
            this.productElement.classList.forEach((classApplied) => {
              if (classApplied.startsWith('color-') || classApplied === 'gradient')
                this.modalContent.classList.add(classApplied);
            });
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();
            this.initBeachCafeGalleryAndAccordion();
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      // Reinitialize the gallery (desktop click-to-show + mobile Slick carousel)
      // and the description/delivery/size accordion, scoped strictly to this
      // modal's own content. The site's shared custom.js and new-media-gallery.liquid
      // scripts only ever run once on the underlying page, so none of this behaviour
      // otherwise applies to content injected here.
      initBeachCafeGalleryAndAccordion() {
        if (typeof jQuery === 'undefined') return;
        var $ = jQuery;
        var $modalContent = $(this.modalContent);

        // Desktop gallery: click a thumbnail to show its image.
        var $desktopSlider = $modalContent.find('.product-main-slider').not('.product-main-slider-mobile');
        if ($desktopSlider.length) {
          var $desktopThumbs = $modalContent.find('.product-thumbnail-slider').not('.product-thumbnail-slider-mobile');
          $desktopThumbs.find('.slider__slide').off('click.bcQuickAdd').on('click.bcQuickAdd', function () {
            var index = $(this).index();
            $desktopSlider.find('.media').removeClass('active').eq(index).addClass('active');
            $desktopThumbs.find('.slider__slide').removeClass('active').eq(index).addClass('active');
          });
          $desktopSlider.find('.media').removeClass('active').eq(0).addClass('active');
          $desktopThumbs.find('.slider__slide').removeClass('active').eq(0).addClass('active');
        }

        // Mobile gallery: same Slick carousel setup used on the main page.
        var $mobileSlider = $modalContent.find('.product-main-slider-mobile');
        if (
          $mobileSlider.length &&
          $mobileSlider.find('.product__media-item').length > 1 &&
          !$mobileSlider.hasClass('slick-initialized') &&
          typeof $mobileSlider.slick === 'function'
        ) {
          $mobileSlider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: true,
            responsive: [
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            ]
          });
        }

        // Accordion: collapse everything except the first entry, matching the
        // main page's default state, and wire up click-to-expand.
        var $accHeads = $modalContent.find('.acc-head');
        if ($accHeads.length) {
          $modalContent.find('.acc-text').hide();
          $accHeads.removeClass('active');
          $accHeads.first().addClass('active');
          $accHeads.first().next('.acc-text').show();
          $accHeads.off('click.bcQuickAdd').on('click.bcQuickAdd', function () {
            var $content = $(this).next('.acc-text');
            if ($content.is(':visible')) {
              $content.slideUp();
              $(this).removeClass('active');
            } else {
              $modalContent.find('.acc-text').slideUp();
              $accHeads.removeClass('active');
              $content.slideDown();
              $(this).addClass('active');
            }
          });
        }
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector('variant-selects');
        if (!variantPicker) return;

        variantPicker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = this.productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        this.productElement.querySelectorAll('variant-selects, product-info').forEach((element) => {
          element.dataset.originalSection = sectionId;
        });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        const desktopColumns = product.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
